import 'style-loader!./alert.css';
import h from 'hyperscript';
import escapeAndMark from 'cadenza/utils/escape-and-mark';

const types = ['error', 'info', 'success', 'warning'];

class Alert extends HTMLElement {

  constructor () {
    super();
    this._title = h('p.title');
    this._message = h('p.message', {hidden: true});
  }

  connectedCallback () {
    this.setAttribute('role', 'alert');
    this.classList.add('d-alert');
    this.append(this._title, this._message);
  }

  set type (value) {
    if (types.includes(value)) {
      types.forEach(type => this.classList.toggle(`d-alert-${type}`, (value === type)));
    }
  }

  get type () {
    return types.find(type => this.classList.contains(`d-alert-${type}`)) || Alert.ERROR;
  }

  set title (text) {
    this._title.innerHTML = escapeAndMark(text);
  }

  set message (text) {
    this._message.innerHTML = escapeAndMark(text);
    this._message.hidden = !text;
  }

}

types.forEach(type => { Alert[type.toUpperCase()] = type; });

customElements.define('d-alert', Alert);
